export class ListNotebooksFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "IdFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListNotebooksFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
